export const inputRow = {
  padding: "5px",
};

export const submitbtnRow = {
  display: "flex",
  justifyContent: "flex-end",
  gap: "1rem",
};

export const commonInputStyles: any = {
  className: "backgroundWhite-description",
  size: "small",
  variant: "outlined",
  fullWidth: true,
};
